import { render, staticRenderFns } from "./Aguacate.vue?vue&type=template&id=24a87a2f&"
import script from "./Aguacate.vue?vue&type=script&lang=js&"
export * from "./Aguacate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports